import { INotice } from '../../../interfaces/Notice.interfaces';
import { customAxios } from '../../common/customAxios';

export const getNotices = (): Promise<INotice[]> => {
  return customAxios.get('/notices');
};
